import { z } from "zod";
import {
  ALT_GL_ACCOUNT_ID,
  AMOUNT,
  APP_AMOUNT,
  APPROVAL_STATUS,
  APPROVED_AMOUNT,
  APPROVED_RATE_PER_UNIT,
  APPROVED_UNIT,
  ATTACHMENT,
  BASELINE_DATE,
  BLOCK,
  BLOCK_BY,
  BLOCK_DATE,
  BUDGET_MONTH,
  BUDGET_YEAR,
  COMMENT,
  COMMUNITY,
  DOCUMENT_ID,
  DOCUMENT_TYPE,
  DRCR,
  DUE_DATE,
  GL_ACCOUNT_ID,
  INVOICE_AMOUNT,
  INVOICE_CURRENCY,
  INVOICE_DATE,
  INVOICE_NUMBER,
  INVOICE_REFERENCE,
  ITEM_TEXT,
  LINE_ITEM_COMMENTS,
  LINE_ITEM_TYPE,
  LINE_ITEMS,
  PAYMENT_BLOCK,
  PAYMENT_METHODS,
  PAYMENT_TERMS,
  POSTING_DATE,
  POSTING_MONTH,
  PROPERTY,
  RATE_PER_UNIT,
  UNIT,
  VENDOR_ID,
  YEAR,
  ZONE,
} from "./consts";

export const schema = z.object({
  [DOCUMENT_ID]: z.string().optional(),
  [DOCUMENT_TYPE]: z.string().min(1, "This Field is required"),
  [VENDOR_ID]: z.string().min(1, "This Field is required"),
  [INVOICE_NUMBER]: z.string().min(1, "This Field is required"),
  [INVOICE_DATE]: z.any(),
  [BASELINE_DATE]: z.any(),
  [INVOICE_REFERENCE]: z.string().optional(),
  [INVOICE_AMOUNT]: z.string().min(1, "This Field is required"),
  [INVOICE_CURRENCY]: z.string().min(1, "This Field is required"),
  [APPROVED_AMOUNT]: z.string().min(1, "This Field is required"),
  [PAYMENT_TERMS]: z.string().optional(),
  [DUE_DATE]: z.any().optional(),
  [PAYMENT_METHODS]: z.string().optional(),
  [POSTING_DATE]: z.any(),
  [YEAR]: z.string().min(1, "This Field is required"),
  [POSTING_MONTH]: z.string().min(1, "This Field is required"),
  [PAYMENT_BLOCK]: z.boolean().optional(),
  [BLOCK_DATE]: z.string().optional(),
  [BLOCK_BY]: z.string().optional(),
  [ATTACHMENT]: z.any().optional(),
  [COMMENT]: z.string().optional(),
  [LINE_ITEM_COMMENTS]: z.string().optional(),
  [COMMUNITY]: z.string().optional(),
  [LINE_ITEMS]: z
    .object({
      [GL_ACCOUNT_ID]: z.string().optional(),
      [ALT_GL_ACCOUNT_ID]: z.string().optional(),
      [DRCR]: z.string().optional(),
      [UNIT]: z.string().optional(),
      [RATE_PER_UNIT]: z.string().optional(),
      [AMOUNT]: z.string().optional(),
      [APPROVED_UNIT]: z.string().optional(),
      [APPROVED_RATE_PER_UNIT]: z.string().optional(),
      [APP_AMOUNT]: z.string().optional(),
      [BUDGET_YEAR]: z.string().optional(),
      [BUDGET_MONTH]: z.any().optional(),
      [ITEM_TEXT]: z.any().optional(),
      [LINE_ITEM_TYPE]: z.string().optional(),
      [APPROVAL_STATUS]: z.any().optional(),
      [ZONE]: z.string().optional(),
      [BLOCK]: z.string().optional(),
      [PROPERTY]: z.string().optional(),
    })
    .array(),
});

export type formValues = z.infer<typeof schema>;
